/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_No_Plan_BodyInputs */

const en_us2_workout_no_plan_body = /** @type {(inputs: Workout_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up your plan to start training.`)
};

const pt_br2_workout_no_plan_body = /** @type {(inputs: Workout_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monte seu plano para começar a treinar.`)
};

const es_419_workout_no_plan_body = /** @type {(inputs: Workout_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arma tu plan para empezar a entrenar.`)
};

const pt_pt2_workout_no_plan_body = /** @type {(inputs: Workout_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cria o teu plano para começares a treinar.`)
};

const fr_fr2_workout_no_plan_body = /** @type {(inputs: Workout_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crée ton programme pour commencer à t'entraîner.`)
};

const de_de2_workout_no_plan_body = /** @type {(inputs: Workout_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richte deinen Plan ein, um mit dem Training zu beginnen.`)
};

const it_it2_workout_no_plan_body = /** @type {(inputs: Workout_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepara la tua scheda per iniziare ad allenarti.`)
};

/**
* | output |
* | --- |
* | "Set up your plan to start training." |
*
* @param {Workout_No_Plan_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_no_plan_body = /** @type {((inputs?: Workout_No_Plan_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_No_Plan_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_no_plan_body(inputs)
	if (locale === "es-419") return es_419_workout_no_plan_body(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_no_plan_body(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_no_plan_body(inputs)
	if (locale === "de-DE") return de_de2_workout_no_plan_body(inputs)
	if (locale === "it-IT") return it_it2_workout_no_plan_body(inputs)
	return en_us2_workout_no_plan_body(inputs)
});
export { workout_no_plan_body as "workout.no_plan_body" }